module.exports = __webpack_public_path__ + "static/builder-factory@2x-eabbb20d713c3829db8bd0d589bc9543.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/android-app-builder/builder-factory@2x.jpg
// module id = 2533
// module chunks = 168707334958949